import React, { useState } from "react";
import "./password-management.css";
import InputText from "../../../../ui/atoms/inputs/input-text/InputText";
import Button from "../../../../ui/atoms/buttons/Button";
import Loading from "../../../../ui/atoms/loading/Loading";
import MessageBox from "../../../../ui/atoms/message-box/MessageBox";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { wait } from "../../../../core/utils/helpers";
import { PasswordSchema } from "../../../../core/utils/validators/authentication";

import { onChangePassword } from "../../services/settings";
import moment from "moment";
import useAxiosPrivate from "../../../../app/providers/context-provider/useAxiosPrivate";
import useLogout from "../../../../app/providers/context-provider/useLogout";

const PasswordManagement = ({ user_id }) => {
  const axiosPrivate = useAxiosPrivate();
  const logout = useLogout();

  const [isSending, setIsSending] = useState(false);
  const [isShowingMsgBox, setIsShowingMsgBox] = useState(false);
  const [messageData, setMessageData] = useState({ type: "", text: "" });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onTouched",
    resolver: yupResolver(PasswordSchema),
    defaultValues: {
      user_id: user_id,
    },
  });

  const hideMessage = (delay = 2000) => {
    setTimeout(() => {
      setIsShowingMsgBox(false);
      setMessageData({ type: "", text: "" });
    }, delay);
  };

  const showMessage = (type, text, delay = 2000) => {
    setIsShowingMsgBox(true);
    setMessageData({ type, text });

    hideMessage(delay);
  };

  const onSubmit = async (data) => {
    try {
      setIsSending(true);

      await wait(700);

      const response = await onChangePassword(axiosPrivate, data);

      const responseData = response?.data;

      // SUCCESS
      if (responseData?.status) {
        showMessage("success", responseData?.message);

        reset();

        setTimeout(async () => {
          await logout();
        }, 2000);

        return;
      }

      // BUSINESS ERROR
      showMessage("warning", responseData?.message, 3000);
    } catch (error) {
      const errorMessage = !error?.response
        ? "No server response"
        : error?.response?.data?.detail?.message || "Something went wrong";

      showMessage("warning", errorMessage);
    } finally {
      setIsSending(false);
    }
  };

  return (
    <form className="password-form" onSubmit={handleSubmit(onSubmit)}>
      {isShowingMsgBox && (
        <div className="w-full mb-xs">
          <MessageBox type={messageData?.type} msg={messageData?.text} />
        </div>
      )}
      <div className="w-full pt-md pb-md">
        <div className="w-full mb-xs">
          <InputText
            type={"text"}
            register={register}
            name="old_password"
            title={"Old Password"}
            error={errors?.old_password?.message}
          />
        </div>
        <div className="w-full mb-xs">
          <InputText
            type={"text"}
            register={register}
            name="password"
            title={"New Password"}
            error={errors?.password?.message}
          />
        </div>
        <div className="w-full mb-xs">
          <InputText
            type={"text"}
            register={register}
            name="confirm_password"
            title={"Confirm New Password"}
            error={errors?.confirm_password?.message}
          />
        </div>
      </div>
      {isSending ? (
        <Loading type={"type-1"} />
      ) : (
        <div className="w-full">
          <Button
            type={"submit"}
            preferedStyle={"normal"}
            title={"Validate and Confirm Password"}
            action={() => {}}
          />
        </div>
      )}
    </form>
  );
};

export default PasswordManagement;
